import { ContentItem } from '..';

export class VideoContentItem extends ContentItem {
  title: string = '';
  videoString: string = '';

  private _thumbnail: string = '';
  private _video: string = '';
  private _embedLink: string = '';
  private _embedUrl: string = '';

  get thumbnail() { return this._thumbnail; }
  get video() { return this._video; }
  get embedLink() { return this._embedLink; }
  get embedUrl() { return this._embedUrl; }

  constructor(json: any) {
    super();
    this._type = 'video';
    if (json.thumbnail) this.thumbnail = json.thumbnail;
    if (json.video) this.video = json.video;
    if (json.embed_link) this.embedLink = json.embed_link;
    if (json.title) this.title = json.title;
    this.updateVideoString();
  }

  set thumbnail(thumbnail: string) {
    this._thumbnail = thumbnail;
  }

  set video(video: string) {
    this._video = video;
    this._embedLink = '';
    this.updateVideoString();
  }

  set embedLink(embed: string) {
    this._embedLink = embed;
    this._video = '';
    this._thumbnail = '';
    
    let video = document.createElement('div');
    video.innerHTML = embed;
    this._embedUrl = (<any>video.firstChild).src;
    this.updateVideoString();
  }

  updateVideoString() {
    if (this.embedLink) {
      let splitEmbed = this._embedLink.split(' ');
      if (splitEmbed.length && splitEmbed[3] && splitEmbed[3].substr(0, 3) === 'src') {
        this.videoString = splitEmbed[3].substring(5, splitEmbed[3].length - 1);
      }
    } else if (this.video) {
      let splitVideoUrl = this.video.split('%2F');
      if (splitVideoUrl.length && splitVideoUrl[2]) {
        this.videoString = splitVideoUrl[2].replace(/\+/g, ' ')
      }
    } else {
      this.videoString = '';
    }
  }

  copy() {
    return new VideoContentItem(this.toJson());
  }

  toJson() {
    let json: any = {
      content_type: this.embedLink ? 'youtube-video' : 'video',
      thumbnail: this.thumbnail,
      title: this.title
    };
    
    if (this.video) json.video = this.video;
    else if (this.embedLink) json.embed_link = this.embedLink;
    return json;
  }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/video-content-item.model.ts